import { Component, OnInit } from '@angular/core';

import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';

@Component({
    selector: 'app-report-template-editor-data-config',
    templateUrl: './report-template-editor-data-config.component.html',
    standalone: false
})
export class ReportTemplateEditorDataConfigComponent extends BaseControlComponent {

  static componentName = "ReportTemplateEditorDataConfigComponent";

  constructor(public readonly contextService: ContextInteractionService) {
    super(contextService);
  }

  ngOnInit() {
  }

}
